import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { YouTubePlayer } from '@angular/youtube-player';
import { KzIconsRegistryService } from '../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsPlay } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-play.icon';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  @Input() public video: string;
  @Input() public maxWidth: string;
  @Input() public suggestedQuality: string; // eg : 'hd720'
  @Input() public ratioContainer: number;
  @Input() public gtmSuffix: string;
  @Input() public buttonSize : 'small' | 'large' = 'large';

  @ViewChild(YouTubePlayer) youtubePlayer!: YouTubePlayer;

  public $playerIsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public $playerIsPlaying: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public $playVideo: Subject<boolean> = new Subject();

  private playVideoSubscription: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsPlay]);
  }

  ngOnInit(): void {
    this.initVideo();
  }

  ngOnDestroy(): void {
    if (this.playVideoSubscription) {
      this.playVideoSubscription.unsubscribe();
    }
  }


  initVideo(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.video) {
        console.error('No video ID provided');
      }

      const script = document.getElementById('iframeYoutube');

      if (!script) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.id = 'iframeYoutube'
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

      this.playVideoSubscription = this.$playVideo.pipe(
        tap(() => this.$playerIsLoaded.next(true)),
        tap(() => {
          this.youtubePlayer.playVideo();
          this.$playerIsPlaying.next(true);
        })
      ).subscribe();
    }
  }
}
